import React from 'react';
import { useParams } from 'react-router-dom';
import HeaderFirst from 'utils/HeaderFirst';
import SaisieEcritures from './components/SaisieEcritures';

// Page dediee "Saisie manuelle" : meme composant que l'onglet de la page
// Comptabilite, uniquement le positionnement change (route propre).
const SaisieManuellePage = () => {
  const { clientID: dossier_id } = useParams();

  return (
    <div>
      <HeaderFirst
        nom={
          <div>
            <h4 className="titre-dossier">Saisie manuelle</h4>
          </div>
        }
        description={<div>Saisissez directement vos ecritures comptables.</div>}
      />
      <SaisieEcritures dossier_id={dossier_id} />
    </div>
  );
};

export default SaisieManuellePage;
